module.exports = __webpack_public_path__ + "static/app-store-badge-inner-0b7bf2bf9ed36149825e7acd6b83e107.svg";